// @ngInject
function AuthApiService($q,DS,DSHttpAdapter,ResourcesService) {

    return {
        getToken: getToken
    };

    function getToken(username, password, tenantName) {
        var deferred = $q.defer();

        var data = {
            'username': username,
            'password': password,
            'tenantName': tenantName
        };

        DSHttpAdapter.POST(DS.defaults.basePath + 'auth', data).then(function(response) {
            deferred.resolve(response.data.token);
        },function(error) {
            deferred.reject(handleError(error));
        });

        return deferred.promise;
    }

    function handleError(error) {
        return ResourcesService.handleResourceError(error);
    }
}

angular
    .module('auth.api',[])
    .factory('AuthApiService', AuthApiService);
